// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160301/js/" + chunkId + "." + {"44":"de248c0f","225":"7a07b682","481":"717e12f5","486":"1064ba20","770":"d2905e7a"}[chunkId] + ".0.6615661829427236.chunk.js";
};